const SectionLayout = ({ children, title }) => {
  return (
    <div className="w-full bg-background rounded-xl overflow-hidden" >
      <div className="bg-primary text-white px-4 py-3">
        <h2 className="font-medium mb-0">{title}</h2>
      </div>
      <div className="divide-y">
        {children}
      </div>
    </div >
  )
}

export default SectionLayout
